import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const StatusToggleButton = ({ isActive, onStatusChange, itemId }) => {
  const [status, setStatus] = useState(isActive);

  useEffect(() => {
    setStatus(isActive);
  }, [isActive]);

  const toggleStatus = async () => {
    try {
      await onStatusChange(itemId, !status);
      setStatus(!status);
      toast.success(`Status changed to ${!status ? "Active" : "Inactive"}`, {
        autoClose: 1000,
      });
    } catch (error) {
      toast.error("Failed to update status", { autoClose: 1000 });
    }
  };

  return (
    <div onClick={toggleStatus} className="cursor-pointer">
      <p
        className={`inline-flex rounded-full bg-opacity-10 py-1 px-3 text-sm font-medium ${
          status ? "bg-green-400 text-green-700" : "bg-red-400 text-red-700"
        }`}
      >
        {status ? "Activated" : "Deactivated"}
      </p>
    </div>
  );
};

export default StatusToggleButton;
